import React, { useState } from 'react';

const API = 'http://localhost:8000/api/v1';

function Contracts() {
  const [text, setText] = useState('');
  const [signatureStatus, setSignatureStatus] = useState('');

  const generate = async (e) => {
    e.preventDefault();
    const form = new FormData(e.target);
    const res = await fetch(API + '/docs/generate', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(Object.fromEntries(form)),
    });
    const data = await res.json();
    setText(data.text);
    setSignatureStatus('');
  };

  const signDocument = () => {
    setSignatureStatus('pending');
    setTimeout(() => {
      setSignatureStatus('done');
    }, 2000);
  };

  const downloadPDF = () => {
    if (!text) return;
    const blob = new Blob([text], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'Договор_Khepri.txt';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  return (
    <div>
      <h2>Генератор договоров</h2>
      <form onSubmit={generate} style={{ display: 'flex', flexDirection: 'column', gap: 10, marginTop: 12 }}>
        <select name="contract_type" style={{ padding: 10, background: '#0F172A', border: '1px solid #334155', borderRadius: 8, color: '#F8FAFC' }}>
          <option value="service">Услуги</option>
          <option value="supply">Поставка</option>
          <option value="nda">NDA</option>
        </select>
        <input name="customer" placeholder="Заказчик" defaultValue="ООО Заказчик" style={{ padding: 10, background: '#0F172A', border: '1px solid #334155', borderRadius: 8, color: '#F8FAFC' }} />
        <input name="executor" placeholder="Исполнитель" defaultValue="ООО Исполнитель" style={{ padding: 10, background: '#0F172A', border: '1px solid #334155', borderRadius: 8, color: '#F8FAFC' }} />
        <input name="subject" placeholder="Предмет договора" defaultValue="Консультационные услуги" style={{ padding: 10, background: '#0F172A', border: '1px solid #334155', borderRadius: 8, color: '#F8FAFC' }} />
        <input name="amount" placeholder="Сумма" defaultValue="500000" style={{ padding: 10, background: '#0F172A', border: '1px solid #334155', borderRadius: 8, color: '#F8FAFC' }} />
        <input name="deadline" type="date" defaultValue="2026-12-31" style={{ padding: 10, background: '#0F172A', border: '1px solid #334155', borderRadius: 8, color: '#F8FAFC' }} />
        <button type="submit" style={{ padding: 12, background: '#6366F1', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600 }}>Сгенерировать</button>
      </form>

      {text && (
        <div style={{ marginTop: 16 }}>
          <pre style={{ padding: 16, background: '#1E293B', borderRadius: 8, whiteSpace: 'pre-wrap', fontSize: 13 }}>{text}</pre>

          <div style={{ marginTop: 12, display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
            <button
              onClick={signDocument}
              disabled={signatureStatus === 'pending' || signatureStatus === 'done'}
              style={{
                padding: '10px 24px',
                background: signatureStatus === 'done' ? '#10B981' : signatureStatus === 'pending' ? '#F59E0B' : '#6366F1',
                color: '#fff',
                border: 'none',
                borderRadius: 8,
                cursor: signatureStatus === 'done' ? 'default' : 'pointer',
                fontWeight: 600,
              }}
            >
              {signatureStatus === 'done' ? '✓ Подписан (УКЭП)' : signatureStatus === 'pending' ? 'Подписание...' : 'Подписать УКЭП'}
            </button>

            <button
              onClick={downloadPDF}
              style={{
                padding: '10px 24px',
                background: '#334155',
                color: '#fff',
                border: 'none',
                borderRadius: 8,
                cursor: 'pointer',
                fontWeight: 600,
              }}
            >
              📄 Скачать файл
            </button>

            {signatureStatus === 'done' && (
              <span style={{ color: '#10B981', fontSize: 13 }}>
                Документ юридически подписан. Подпись PKCS#7 прикреплена.
              </span>
            )}
          </div>

          <p style={{ color: '#94A3B8', fontSize: 12, marginTop: 8 }}>
            ⚠️ Демо подписи УКЭП. Полная интеграция с КриптоПРО появится в следующем обновлении.
          </p>
        </div>
      )}
    </div>
  );
}

export default Contracts;